var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c("div", { staticClass: "left" }, [
      _c("img", { attrs: { src: _vm._f("profilePicture")(_vm.professional) } }),
      _vm._v(" "),
      _c("div", { staticClass: "header-content" }, [
        _c("span", { staticClass: "name" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("firstName")(_vm.professional)) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "order-count" }, [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm._f("minOrderCount")(_vm._f("orderCount")(_vm.professional))
              ) + " limpezas"
            )
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(" realizadas")])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right" }, [
      _c("span", { staticClass: "text" }, [_vm._v(_vm._s(_vm.currentState))]),
      _vm._v(" "),
      _c("div", { staticClass: "countdown" }, [
        _vm.time
          ? _c(
              "div",
              [
                _c("span", [_vm._v(_vm._s(_vm.time))]),
                _vm._v(" "),
                _c("ProgressBar", {
                  attrs: { progress: _vm.percentageTimeLeft() }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.paid && !_vm.isOrderOnPast
          ? _c("div", [
              _c("span", [_vm._v(_vm._s(_vm._f("days")(_vm.daysLeft)))])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1333f324", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1333f324","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Components/Card/Header.vue
// module id = null
// module chunks = 